export default __webpack_public_path__ + "static/media/upload_camera_icon.3dde55bb.png";